import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { LatLngExpression } from "leaflet";
import "leaflet/dist/leaflet.css";
import { CityInput } from "../components/CityInput/CityInput";
import styled, { css } from "styled-components/macro";

const SampleMapPage = () => {
  const position: LatLngExpression = [48.864716, 2.349];
  return (
    <div className="page">
      <StyledCityInput
        id={"cityInput"}
        placeholder={""}
        title={"City Input"}
        value={null}
        errorMessage={""}></StyledCityInput>
      <MapContainer
        style={{ height: 536, zIndex: 1 }}
        center={position}
        zoom={13}
        scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>
            A pretty CSS3 popup. <br /> Easily customizable.
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export const InputStyle = css`
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 2.4rem;
  width: 300px;
`;

const StyledCityInput = styled(CityInput)`
  & input {
    ${InputStyle}
  }
` as typeof CityInput; // we need to do this as styled components doesn't return the generic type


export default SampleMapPage;
